module.exports = __webpack_public_path__ + "img/max-file-deny--pdf.20465bb5.svg";